import { BigCommerceApiKeys as keys } from './bigCommerceActionKeys';
import * as types from './bigCommerceActionTypes';
import { IBigCommerceShipTypeMap, IBigCommerceStore } from './bigCommerceInterfaces';

export const bigCommerceActionCreators = {
  deleteShipMethod: (bigCommerceShipTypeMapId: number): types.DeleteBigCommerceShipMethod => ({
    payload: { bigCommerceShipTypeMapId },
    type: keys.DELETE_BIG_COMMERCE_SHIP_METHOD
  }),
  deleteStore: (bigCommerceStoreId: number): types.DeleteBigCommerceStore => ({
    payload: { bigCommerceStoreId },
    type: keys.DELETE_BIG_COMMERCE_STORE
  }),
  fetchShipMethods: (): types.FetchBigCommerceShipMethods => ({
    type: keys.FETCH_BIG_COMMERCE_SHIP_METHODS
  }),
  fetchStores: (): types.FetchBigCommerceStores => ({
    type: keys.FETCH_BIG_COMMERCE_STORES
  }),
  removeShipMethod: (bigCommerceShipTypeMapId: number): types.RemoveBigCommerceShipMethod => ({
    payload: { bigCommerceShipTypeMapId },
    type: keys.REMOVE_BIG_COMMERCE_SHIP_METHOD
  }),
  removeStore: (bigCommerceStoreId: number): types.RemoveBigCommerceStore => ({
    payload: { bigCommerceStoreId },
    type: keys.REMOVE_BIG_COMMERCE_STORE
  }),
  setShipMethods: (payload: IBigCommerceShipTypeMap[]): types.SetBigCommerceShipMethods => ({
    payload,
    type: keys.SET_BIG_COMMERCE_SHIP_METHODS
  }),
  setStores: (payload: IBigCommerceStore[]): types.SetBigCommerceStores => ({
    payload,
    type: keys.SET_BIG_COMMERCE_STORES
  }),
  updateShipMethod: (payload: IBigCommerceShipTypeMap): types.UpdateBigCommerceShipMethod => ({
    payload,
    type: keys.UPDATE_BIG_COMMERCE_SHIP_METHOD
  }),
  updateStore: (payload: IBigCommerceStore): types.UpdateBigCommerceStore => ({
    payload,
    type: keys.UPDATE_BIG_COMMERCE_STORE
  })
};
